import { Route } from '@angular/router';
import { authGuard } from '@olonera/auth';
import { AuthenticatedLayoutComponent } from './features/authenticated-layout/authenticated-layout';
import { PageNotFoundComponent, AccessDeniedComponent } from '@olonera/ui';

export const appRoutes: Route[] = [
    {
        path: 'auth',
        loadChildren: () => import('@olonera/auth').then(m => m.AUTH_ROUTES),
        data: { isAdminApp: true }
    },
    {
        path: '',
        canActivate: [authGuard],
        component: AuthenticatedLayoutComponent,
        children: [
            { path: 'dashboard', loadComponent: () => import('./features/dashboard/dashboard').then(m => m.DashboardComponent) },
            { path: 'messages', loadComponent: () => import('./features/messages/messages').then(m => m.MessagesComponent) },
            {
                path: 'specialists',
                loadComponent: () => import('./features/practitioners/practitioners-list.component').then(m => m.PractitionersListComponent)
            },
            {
                path: 'specialists/:id',
                loadComponent: () => import('./features/practitioners/practitioner-detail.component').then(m => m.PractitionerDetailComponent)
            },
            {
                path: 'resources',
                children: [
                    {
                        path: '',
                        loadComponent: () => import('./features/resources/admin-resources.component').then(m => m.AdminResourcesComponent)
                    },
                    {
                        path: 'new',
                        loadComponent: () => import('./features/resources/admin-resource-editor.component').then(m => m.AdminResourceEditorComponent)
                    },
                    {
                        path: ':id/edit',
                        loadComponent: () => import('./features/resources/admin-resource-editor.component').then(m => m.AdminResourceEditorComponent)
                    }
                ]
            },
            {
                path: 'protocol-templates',
                children: [
                    {
                        path: '',
                        loadComponent: () => import('./features/protocol-templates/admin-templates.component').then(m => m.AdminTemplatesComponent)
                    },
                    {
                        path: ':id',
                        loadComponent: () => import('./features/protocol-templates/admin-template-detail.component').then(m => m.AdminTemplateDetailComponent)
                    }
                ]
            },
            { path: 'system', loadComponent: () => import('./features/dashboard/dashboard').then(m => m.DashboardComponent) },
            { path: 'analytics', loadComponent: () => import('./features/dashboard/dashboard').then(m => m.DashboardComponent) },
            { path: 'logs', loadComponent: () => import('./features/audit-logs/audit-logs.component').then(m => m.AuditLogsComponent) },
            { path: 'logs/:id', loadComponent: () => import('./features/audit-logs/audit-log-detail.component').then(m => m.AuditLogDetailComponent) },
            { path: 'settings', loadComponent: () => import('./features/settings/settings').then(m => m.AdminSettingsComponent) },
            {
                path: 'access-denied',
                component: AccessDeniedComponent
            },
            { path: '', redirectTo: 'dashboard', pathMatch: 'full' }
        ]
    },
    { path: '**', component: PageNotFoundComponent }
];
